/**
 * Returns a trimmed https URL string, or `undefined` if the value is not a
 * usable booking URL (wrong type, whitespace-only, non-https, or malformed).
 */
export function parseValidHttpsUrl(value: unknown): string | undefined {
  if (typeof value !== 'string') return undefined;
  const trimmed = value.trim();
  if (!trimmed) return undefined;
  try {
    if (new URL(trimmed).protocol !== 'https:') return undefined;
    return trimmed;
  } catch {
    return undefined;
  }
}
